import { render, staticRenderFns } from "./ReplyGroupList.vue?vue&type=template&id=5863cbb2&scoped=true"
import script from "./ReplyGroupList.vue?vue&type=script&lang=js"
export * from "./ReplyGroupList.vue?vue&type=script&lang=js"
import style0 from "./ReplyGroupList.vue?vue&type=style&index=0&id=5863cbb2&prod&lang=scss&scoped=true"
import style1 from "./ReplyGroupList.vue?vue&type=style&index=1&id=5863cbb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5863cbb2",
  null
  
)

export default component.exports